import { render, staticRenderFns } from "./LmError.vue?vue&type=template&id=674afcb6&scoped=true"
import script from "./LmError.vue?vue&type=script&lang=js"
export * from "./LmError.vue?vue&type=script&lang=js"
import style0 from "./LmError.vue?vue&type=style&index=0&id=674afcb6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674afcb6",
  null
  
)

export default component.exports